import { matchRoutes, useLocation } from 'react-router-dom';

import type { HMPageConfig } from '@/modules/hiring-manager/pages';
import { hmPages, hmRoutes } from '@/modules/hiring-manager/pages';

export const useCurrentHMPageConfig = (): HMPageConfig | undefined => {
  const location = useLocation();
  const matches = matchRoutes(hmRoutes, location);

  const pageConfig = matches
    ? hmPages.find((page) => page.path === matches[0]?.route.path)
    : undefined;

  return pageConfig;
};
